import { AnyAction } from 'redux';

import {
  FETCH_ASSESSMENT_MESSAGES,
  UPDATE_PAGE_ASSESSMENT_MESSAGES,
} from 'actions/messages/types';
import { CheckMessage } from 'types/check';
import {
  IFetchAssessmentMessages,
  IFetchPageAssessmentMessages,
} from 'actions/messages/index';

export type MessagesReducerType = {
  messages: CheckMessage[];
};

export const initialState = (): MessagesReducerType => {
  return {
    messages: [],
  };
};

function handleFetchAssessmentMessages(
  state: MessagesReducerType,
  action: IFetchAssessmentMessages
): MessagesReducerType {
  return {
    ...state,
    messages: [...state.messages, ...action.messages],
  };
}

function updatePageAssessmentMessages(
  state: MessagesReducerType,
  action: IFetchPageAssessmentMessages
): MessagesReducerType {
  const stateExceptPageMessages = state.messages.filter((msg: CheckMessage) => {
    return msg.level !== 'PAGE';
  });
  const statePageOnlyMessages = state.messages.filter((msg: CheckMessage) => {
    return msg.level === 'PAGE';
  });
  const statePageExceptNewAddedByCode = statePageOnlyMessages.filter(
    (stateMsg: CheckMessage) => {
      return !action.messages.some(
        (newMsg: CheckMessage) => newMsg.code === stateMsg.code
      );
    }
  );

  return {
    ...state,
    messages: [
      ...stateExceptPageMessages,
      ...statePageExceptNewAddedByCode,
      ...action.messages,
    ],
  };
}

export default function AssessmentReducer(
  state = initialState(),
  action: AnyAction
) {
  switch (action.type) {
    case FETCH_ASSESSMENT_MESSAGES:
      return handleFetchAssessmentMessages(
        initialState(),
        action as IFetchAssessmentMessages
      );
    case UPDATE_PAGE_ASSESSMENT_MESSAGES:
      return updatePageAssessmentMessages(
        state,
        action as IFetchPageAssessmentMessages
      );
    default:
      return state;
  }
}
